<template>
    <div class="container">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <p class="heading has-text-weight-bold is-size-5">User Roles</p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="columns"  style="justify-content: right;">
                            <div class="column has-text-right">
                                <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                                    <div class="tooltiptext">
                                        <ul style="list-style: disc outside">
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can see the user roles</p>
                                            </li>
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can activate/deactivate the user role.</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-roles-table">
            <table class="table is-hoverable is-fullwidth is-bordered is-striped animate__animated animate__slideInUp animate__faster">
                <thead>

                <tr class="">
                    <th style="width: 10%" v-for="role in roles" :key="role.id">
                        <span v-if="role.id == 0">Roles</span>
                        <span  v-if="role.id > 0">{{role.name}}</span>
                    </th>
                </tr>

                </thead>
                <tbody>
                        <tr style="width: 10%"  v-for="permission in permissions" :key="permission.id">
                                <td style="width: 10%;">{{permission.key}}</td>
                                <td v-for="role in roles.slice(1)" :key="role.id">
                                     <span v-if="role.id>0">
                                            <button class="button is-small is-light"
                                                  :class="{'is-success': CheckPermissionForRole(role.id,permission.id),'is-danger' : !CheckPermissionForRole(role.id,permission.id)}"
                                                  @click="CheckPermissionForRole(role.id,permission.id)? tryDeleteRolePermission(role.id,permission.id) : tryAddRolePermission(role.id,permission.id)">
                                              <font-awesome-icon icon="eye"/>
                                            </button>
                                     </span>
                                </td>
                        </tr>
                </tbody>
            </table>

        </div>
    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex";

    const {mapState, mapActions} = createNamespacedHelpers("roles");

    export default {
        name: "UserRoles",
        data() {
            return {
                RoleForm: {
                    RoleId: 0,
                    PermissionId: 0
                }
            }
        },

        created() {
            this.GetRoles();
            this.GetRolesWithPermission();
            this.GetPermissions();
        },

        methods: {
            ...mapActions(["GetPermissions", "GetRolesWithPermission", "GetRoles", "addPermissionRole", "deletePermissionRole"]),
            tryAddRolePermission(roleId, permissionId) {
                try {
                    this.RoleForm.RoleId = roleId;
                    this.RoleForm.PermissionId = permissionId;
                    this.addPermissionRole(this.RoleForm);
                    this.$notify({title: "Success", text: "You have add permission in successfully.", type: "success"});
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on tryAddRolePermission function "+e.message, type: "error"});
                }
            },

            tryDeleteRolePermission(roleId, permissionId) {
                try {
                    this.RoleForm.RoleId = roleId;
                    this.RoleForm.PermissionId = permissionId;
                    this.deletePermissionRole(this.RoleForm);
                    this.$notify({
                        title: "Success",
                        text: "You have delete permission in successfully.",
                        type: "success"
                    });
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on tryDeleteRolePermission function "+e.message, type: "error"})
                }
            },

            CheckPermissionForRole(roleid,permid)
            {
                var result = this.rolesWithPermissions.filter(x=>x.roleId==roleid).filter(x=>x.permissionId==permid)

                if(result.length > 0)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
        },

        computed: {
            ...mapState([
                "permissions",
                "roles",
                "rolesWithPermissions",
                // "userPermissions",
                // "administratorPermissions",
                // "dispatcherPermissions",
                // "occPermissions",
                // "dataPermissions",
                // "efbPermissions"
            ])
        }
    }
</script>

<style scoped>

    .user-roles-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .user-roles-table td {
        border: 0px;
    }

    .user-roles-table {
        /*overflow-y: scroll;*/
        /*height: 790px;*/
    }

    .user-roles-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
